module.exports = __webpack_public_path__ + "static/img/cont3618.b9112c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3618.jpg
// module id = fIlM
// module chunks = 0